import React from 'react';
import clip from 'text-clipper';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import LearnosityText from 'legacy/src/components/learnosity/LearnosityText';

import './FrqSingleQuestionPreview.scss';

/**
 *  Preview stimulus out of learnosity getWidget data
 *  NOTE: this assumes we Learnosity provider is loaded already, so we have access to
 *  learnosity.css and MathJax, if necessary.
 */
const FrqSingleQuestionPreview = ({
  header = '',
  stimulus = '',
  remove = () => {},
  edit = () => {},
}) => {
  const truncatedStimulus = clip(stimulus, 1000);

  return (
    <section className="question-preview mb-10">
      <header className="actions">
        <h3 className="mt-0 text-18 font-medium">{header}</h3>
        <div className="flex">
          <ButtonWithIcon
            icon="delete"
            onClick={remove}
            size="small"
            iconWidth="12"
            iconHeight="13"
            className="mr-4"
          />
          <ButtonWithIcon
            icon="edit"
            onClick={edit}
            size="small"
            iconWidth="12"
            iconHeight="13"
          />
        </div>
      </header>

      <div className="lrn content">
        <LearnosityText text={truncatedStimulus} />
      </div>
    </section>
  );
};

export default FrqSingleQuestionPreview;
